import type { StyledComponent } from "@emotion/styled";
import { Box, type BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "GridVirtualizedBoxes";
export const classes = {
  root: `${PREFIX}-root`,
  list: `${PREFIX}-list`,
  items: `${PREFIX}-items`,
};

export const GridVirtualizedBoxes: StyledComponent<BoxProps> = styled(Box)(({ theme }) => ({
  [`&.${classes.list}`]: {
    width: "100%",
    display: "grid",
    gap: theme.spacing(2),
    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
    [theme.breakpoints.down("tablet")]: {
      gridTemplateColumns: "repeat(auto-fill,minmax(100%, auto))",
    },
  },
  [`& .${classes.items}`]: {
    padding: "O.5rem",
    boxSizing: "border-box",
    alignContent: "stretch",
  },
}));
